import React, { useState } from 'react';

export const StorageContext = React.createContext([]);
export const ApplicationContext = React.createContext([]);
export const DesignContext = React.createContext([]);
export const DriverAssistContext = React.createContext([]);
export const PerformanceContext = React.createContext([]);
export const ConnectivityContext = React.createContext([]);

export const StorageProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <StorageContext.Provider value={[data, setter]}>{children}</StorageContext.Provider>;
};

export const ApplicationProvider = ({ children }) => {
    const [data, setter] = useState({});
    return <ApplicationContext.Provider value={[data, setter]}>{children}</ApplicationContext.Provider>;
};

export const DesignProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <DesignContext.Provider value={[data, setter]}>{children}</DesignContext.Provider>;
};

export const DriverAssistProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <DriverAssistContext.Provider value={[data, setter]}>{children}</DriverAssistContext.Provider>;
};

export const PerformanceProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <PerformanceContext.Provider value={[data, setter]}>{children}</PerformanceContext.Provider>;
};

export const ConnectivityProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <ConnectivityContext.Provider value={[data, setter]}>{children}</ConnectivityContext.Provider>;
};
